import {
  TherapistOfficeDistrictsResponseSchema,
  type TherapistOfficeDistrictsResponse,
} from '@hedepy/common/schemas/routes/api/v2/therapist'

import { useApis } from '@/legacy-src/contexts/api-context'

import { useSwrQuery, type SwrQueryOptions } from '@/src/domains/swr/hooks/useSwrQuery'

export const useGetTherapistLocations = <Config extends SwrQueryOptions<TherapistOfficeDistrictsResponse> | undefined>(
  serviceId?: number,
  options?: Config,
) => {
  const { api } = useApis()

  return useSwrQuery(
    [serviceId, 'office-districts', 'therapist', 'GET'],
    async () => {
      if (serviceId === undefined) {
        return []
      }

      const { data } = await api.getTherapistOfficeDistricts(serviceId)

      return TherapistOfficeDistrictsResponseSchema.parse(data)
    },
    options,
  )
}
